<template>
  <div class="profile-tile">
    <div class="field-of-fields">
      <h3>Feedback</h3>
      <hr>
      <label class="top-label">Do you have any feedback on our website and your dashboard and how we can improve your experience? Please let us know!</label>
      <textarea rows="3" class="form-control" v-model="body" placeholder="If something is not working or you have ideas how to make it better, what you like, dislike, design, general thoughts, anything, we'd love to hear from you. (:"></textarea>
      <label>How would you rate your experience? (5 being the best, 1 the worst)</label>
      <div class="form-check" v-for="(ratingOption, index) in ratingOptions" v-bind:key="'rating'+index">
        <input class="form-check-input" type="radio" :id="'rating'+index" :value="ratingOption" v-model="rating">
        <label class="form-check-label ml-1" :for="'rating'+index">
          {{ ratingOption }}
        </label>
      </div>
      <hr>
      <button class="mylisting-button dark-button mt-2" @click="submitFeedback()">Submit Feedback</button>
    </div>

    <modal name="feedback-submitted-modal" width="75%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>We have received your feedback!</h2>
        <h4>Thank you so much, we really appreciate it and will work hard to keep improving your experience. If you have any additional thoughts now or in the future, please don't hesitate to share them!</h4>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('feedback-submitted-modal')" style="">Close</button>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: ['user'],
  data() {
    return {
      rating: '',
      ratingOptions: ['5', '4', '3', '2', '1'],
      body: '',
    }
  },
  methods: {
    submitFeedback() {
      axios.post(`/api/feedback/`, {
        user: this.user.id,
        body: this.body,
        rating: this.rating,
        giver_name: `${this.user.first_name} ${this.user.last_name}`,
        giver_email: this.user.email,
        is_candidate: this.$store.getters.isCandidate,
        is_employer: this.$store.getters.isEmployer,
        is_agent: this.$store.getters.isAgent,
        agency_owner: this.$store.getters.agencyName,
        agency: this.$store.getters.agencyID,
      })
        .then(res => {
          this.$modal.show('feedback-submitted-modal')

          this.$store.dispatch("sendEmails", {
            subject:
              "FEEDBACK " + ` ${this.$store.getters.agencyName}`,
            message:
              "Feedback: " +
              `${this.body}` +
              "\n\nRating: " +
              `${this.rating}` +
              "\n\n" +
              `Agency: ${this.$store.getters.agencyName} \nName: ${this.user.first_name} ${this.user.last_name} \nCandidate? ${this.$store.getters.isCandidate} \Client? ${this.$store.getters.isEmployer} \nEmail: ${this.user.email}`,
            from: 'feedback@enginehire.io',
            emails: [
              this.$store.getters.enginehireLoggingEmail,
              this.$store.getters.enginehireAdminEmail,
              'amisra26@gmail.com',
            ],
            reply: this.$store.getters.agencyReplyEmail,
            // userID: this.aakashid,
            userID: 4
          });

          this.body = ''
          this.rating = ''
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/users/Feedback.vue